import { Box, Stack } from '@mui/material'

import {
  Artist,
  Maybe,
  OrderBy,
  UserCartTransactionOrderConnectionFragment,
} from '@/clients/utoniq-core/schema'
import { ArtistHeaderItemsLeftProps } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { StorePurchaseHistorySkeleton } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import {
  FillterCell,
  OrderItem,
} from '@/components/pages/ConsoleOrders/template'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  loading: boolean
  hasNextPage: boolean
  artistId: string
  user: ArtistHeaderItemsLeftProps['currentUser']
  artist: Maybe<Pick<Artist, 'id' | 'paymentType'>>
  orderTransactions: Maybe<UserCartTransactionOrderConnectionFragment>
  sort: OrderBy
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onFefetch: (orderBy: OrderBy) => Promise<void>
  onFetchMore: () => Promise<void>
}

export const ConsoleUserOrdersTemplate: Template<State, Action> = ({
  state,
  onFefetch,
  onFetchMore,
}) => {
  const { t } = useTranslation('consoleUserOrders')
  const { routerPages, generatePath, router } = useRouter<{ userId: string }>()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <ConsoleBaseLayout
        margin
        header={{
          back: true,
          defaultBackPage: generatePath(routerPages.ConsoleUserDetail, {
            userId: router.query.userId ?? '#',
          }),
          title: t('title'),
        }}
      >
        <Box sx={{ pt: 3 }}>
          <FillterCell
            loading={state.loading}
            orderTransactions={state.orderTransactions}
            onFefetch={onFefetch}
            sort={state.sort}
          />
          <ScrollFetcher
            nodes={state.orderTransactions?.edges.map(({ node }) => (
              <OrderItem key={node.id} order={node} />
            ))}
            loadingComponent={
              <Stack spacing={5} sx={{ pt: 2 }}>
                {Array.from(Array(2).keys()).map(key => (
                  <StorePurchaseHistorySkeleton key={key} />
                ))}
              </Stack>
            }
            componentProps={{ spacing: 5 }}
            loading={state.loading}
            hasNextPage={state.hasNextPage}
            onFetchMore={onFetchMore}
            emptyMessage={t('ordersEmpty')}
          />
        </Box>
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}
